/**
* @NApiVersion 2.x
* @NModuleScope TargetAccount
* // Copyright (c) 2021, Oracle and/or its affiliates. All rights reserved.
* // Licensed under the Universal Permissive License v 1.0 as shown at http://oss.oracle.com/licenses/upl.
*/
define([
  'N/record',
  'N/runtime',
  'N/log',
  'N/search',
   'N/file',
], function (
  record,
  runtime,
  log,
  search,
  file
) {
    'use strict';

    var NusmartSponserProfileModule = {

        get: function (request) {
          //log.debug("request", JSON.stringify(request));

          var getsku = request.parameters.getsku;
            var getdeafultimg =  request.parameters.mopimg;
        //  alert(getsku)
          //log.debug("getsku", JSON.stringify(getsku));

            var self = this;
            var type = 'customsearch_nus_ems_instuprofile';
var searchResults = search.create({
   type: "customrecord_nus_emseventinst",
   filters:
   [
      ["custrecord_nus_asproject.custrecord_eventcode","is",getsku]
   ],
   columns:
   [
      search.createColumn({
         name: "custrecord_nus_ems_itemcode",
         join: "CUSTRECORD_NUS_ASPROJECT",
         label: "Ref Item Code "
      }),
      search.createColumn({
         name: "name",
         join: "CUSTRECORD_EVENTINSTNAME",
         label: "Name"
      }),
      search.createColumn({
         name: "custrecord_nus_ems_category",
         join: "CUSTRECORD_EVENTINSTNAME",
         label: "Category"
      }),
      search.createColumn({
         name: "custrecord_nus_ems_insprofile",
         join: "CUSTRECORD_EVENTINSTNAME",
         label: "Profile Detail"
      }),
      search.createColumn({
         name: "custrecord_nus_ems_instimage",
         join: "CUSTRECORD_EVENTINSTNAME",
         label: "Instructor Image"
      })
   ]
});
  //log.debug('customrecord_nus_emseventinst searchResults', JSON.stringify(searchResults));
    var searchResults = searchResults.run().getRange({start: 0, end: 1000});
      var mappedResults = searchResults.map(function (result,index) {
                var fileInternalId = result.getValue({name: "custrecord_nus_ems_instimage",join: "CUSTRECORD_EVENTINSTNAME"});
                var imageUrl = self.getImageURL(fileInternalId);
                 var unescaped_profile = result.getValue({name: "custrecord_nus_ems_insprofile",join: "CUSTRECORD_EVENTINSTNAME"});
                 /* var profile_ = xmlobj.escape({
                  xmlText: unescaped_profile
              });
*/

             var desc = unescaped_profile;
              if (!desc) {
                  var desc1 = '';
              } else {
                  var desc1 = desc.replace(/<p[^>]*>/g, '<br>').replace(/<\/p>/g, '');
                // Convert <p> tags to newlines
                //desc1 = desc1.replace(/<p>/g, '').replace(/<\/p>/g, '\n');
                // Convert <br> tags to newlines
                //desc1 = desc1.replace(/<br\s*\/?>/g, '\n');
              }
                return {
                  id: index + 1 ,
                  code: result.getText({name: "custrecord_nus_ems_itemcode",join: "CUSTRECORD_NUS_ASPROJECT"}),
                  name: result.getValue({name: "name",join: "CUSTRECORD_EVENTINSTNAME"}),
                  category: result.getText({name: "custrecord_nus_ems_category",join: "CUSTRECORD_EVENTINSTNAME"}),
                  profile: desc1,
                  image: imageUrl ? imageUrl: getdeafultimg,

                }
            });

          return mappedResults;
        } ,
     getImageURL: function (fileInternalId) {
        var self = this;
        try {
          // Load the file by internal ID
          var fileObj = file.load({
            id: fileInternalId
          });

          // Get the URL of the image
          var imageURL = fileObj.url;

          return imageURL;
        } catch (e) {
          log.error('Error', e.message);
          return null;
        }
      }
    }

    return NusmartSponserProfileModule
})
